"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = scorePassword;
// Based on https://stackoverflow.com/a/11268104
function scorePassword(pass) {
  var score = 0;
  if (!pass || pass.length < 5) return score;

  // award every unique letter until 5 repetitions
  var letters = {};
  for (var i = 0; i < pass.length; i++) {
    letters[pass[i]] = (letters[pass[i]] || 0) + 1;
    score += 5.0 / letters[pass[i]];
  }

  // bonus points for mixing it up
  var variations = {
    digits: /\d/.test(pass),
    lower: /[a-z]/.test(pass),
    upper: /[A-Z]/.test(pass),
    nonWords: /\W/.test(pass)
  };
  var variationCount = 0;
  for (var check in variations) {
    variationCount += variations[check];
  }
  score += (variationCount - 1) * 10;
  return Math.min(4, parseInt(score / 20, 10));
}